import { Link } from "react-router";
import { invoiceTotals, useInvoices } from "../../api/invoices.js";
import { AppShell } from "../../components/AppShell.js";
import { EmptyState } from "../../components/EmptyState.js";
import { Skeleton } from "../../components/Skeleton.js";
import { formatDateTime, formatMoney } from "../../lib/format.js";

export function RestaurantInvoicesPage() {
  const { data, isPending } = useInvoices("restaurant");
  const totals = data ? invoiceTotals(data) : null;

  return (
    <AppShell title="청구서">
      {totals ? (
        <p className="mb-4 rounded-xl bg-stone-100 p-4">
          전체 {totals.count}건 · 미결제 <strong>{formatMoney(totals.unpaidTotal)}</strong>
        </p>
      ) : null}
      {isPending ? <Skeleton /> : null}
      {data && data.length === 0 ? <EmptyState message="아직 받은 청구서가 없습니다." /> : null}
      <ul>
        {data?.map((invoice) => (
          <li key={invoice.id} className="border-b border-stone-200 py-3">
            <Link to={`/invoices/${invoice.id}/print`} className="flex items-center justify-between">
              <span>
                <span className="font-medium">{invoice.supplier.name}</span>
                <span className="ml-2 text-sm text-stone-500">
                  {invoice.number} · {formatDateTime(invoice.issuedAt)}
                </span>
              </span>
              <span className="text-right">
                <span className="block font-semibold">{formatMoney(invoice.total)}</span>
                <span className={invoice.paidAt ? "text-sm text-emerald-700" : "text-sm text-stone-500"}>
                  {invoice.paidAt ? "수금 완료" : "미결제"}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </AppShell>
  );
}
